<template>
  <div class="cp-box" v-if="partner">
    <ul class="sub-tabs">
      <li :class="{ active: activeTab === 'profile' }" @click="activeTab = 'profile'"><a>Profile</a></li>
      <li :class="{ active: activeTab === 'contacts' }" @click="activeTab = 'contacts'"><a>Contacts</a></li>
    </ul> 
    <hr v-if="$hasPerm('edit-profile')">
    <registration-data-info v-if="activeTab === 'profile'" :registration="partner" main-profile-only-name hide-basics hide-contacts show-edit />
    <contacts v-if="activeTab === 'contacts'" :registration="partner" :showEditAdd="true"/>
  </div>
</template>

<script>
import Contacts from './ProfileInfoContacts'
import RegistrationDataInfo from './RegistrationDataInfo'

export default {
  components: {
    Contacts,
    RegistrationDataInfo
  },

  props: {
    id: {
      type: [String, Number],
      required: true
    }
  },

  data () {
    return {
      activeTab: 'profile'
    }
  },

  computed: {
    partner () {
      return this.$store.getters['partners/get'](this.id)
    }
  }
}
</script>
